import { AlertFactory, AlertState } from 'alerts/Alert'
import ModalViewModel from 'infra/ModalViewModel'
import JobStore from 'jobs/JobStore'
import { task } from 'mobx-task'

/**
 * View Model for Notify Pros of Unclaimed Jobs Dialog.
 */
export class NotifyProsOfUnclaimedJobsViewModel extends ModalViewModel {
  constructor(
    private readonly jobStore: JobStore,
    private readonly newAlert: AlertFactory,
    private readonly getSelectedWorkspaces: () => string[],
  ) {
    super()
  }

  /**
   * Notifies all pros of unclaimed jobs in the selected workspace.
   */
  notifyPros = task.resolved(async () => {
    const workspaces = this.getSelectedWorkspaces()
    if (workspaces.length !== 1) {
      return
    }

    const workspaceId = workspaces[0]
    const jobsNotified =
      await this.jobStore.bulkNotifyProsOfOpenJobs(workspaceId)

    this.close()

    if (jobsNotified === 0) {
      this.newAlert()
        .withState(AlertState.Neutral)
        .saying('No unclaimed jobs found in this workspace.')
        .autoDismiss()
        .show()
    } else {
      this.newAlert()
        .withState(AlertState.Success)
        .saying(
          `All available pros were successfully notified of ${jobsNotified} unclaimed job${jobsNotified !== 1 ? 's' : ''}.`,
        )
        .autoDismiss()
        .show()
    }
  })
}
